import { findMenuByFullPath, flattenMenus } from "data/data";
import usePermission from "hooks/usePermission";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import MenuInfo from 'data/menu';
import Error404 from "./Error404";
import Error403 from "./Error403";

function RouteAccessError() {
    const location = useLocation();
// console.log(location)
    const { hasPermission, isPermissionReady } = usePermission();

    const menuList = useMemo(() => {
        return flattenMenus(
            MenuInfo.ROOT
        );
    }, []);
// console.log(menuList)

    if (!isPermissionReady) {
        return null;
    }

    const menu = findMenuByFullPath(
        menuList,
        location.pathname
    );

// console.log(menu)
    // const menu = findMenuByPath(menus, location.pathname);

    if (!menu) {
        return <Error404 />;
    }

    const featureOk =
        menu.feature === undefined || menu.feature;

    if (!featureOk) {
        return <Error404 />;
    }

    const permissionOk =
        !menu.permission || hasPermission(menu.permission);

    if (!permissionOk) {
        return <Error403 />;
    }

    return <Error404 />;
}

export default RouteAccessError;